export const getTextSizeByAmount = (amount: number, isMobile: boolean): string => {
  if (amount >= 500) return isMobile ? '18px' : '20px'
  if (amount >= 20) return isMobile ? '10px' : '14px'
  return isMobile ? '6px' : '10px'
}
